module.exports = __webpack_public_path__ + "static/img/project-cabz.ea76bda.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/project-cabz.jpg
// module id = /zoP
// module chunks = 1